export default __webpack_public_path__ + "static/media/f.ua.mobile.c01a48e5.svg";